module.exports = __webpack_public_path__ + "static/img/James-Walsh.ab2b8b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Walsh.jpg
// module id = EB4R
// module chunks = 0